import { paths } from 'common/consts/path.consts';

export const getLinkPathToGgrProject = (projectTransliteration: string) =>
  `${paths.ggr}/${projectTransliteration}/`;
